import { IconClose } from 'components/Icons';
import Typography from 'components/Typography/Typography';
import { htmlId } from 'utils/html';

import { CloseContainer, TextContainer, ToastContainer, ToastContent } from './Toast.styles';
import { ToastProps } from './Toast.types';

const Toast = (props: ToastProps) => {
  const { children, onClick, onClose } = props;
  return (
    <ToastContainer id={htmlId('toast-container')} onClick={onClick}>
      <ToastContent id={htmlId('toast-content')}>
        {children}
        <CloseContainer id={htmlId('toast-close-container')} onClick={onClose}>
          <IconClose />
        </CloseContainer>
      </ToastContent>
    </ToastContainer>
  );
};

const Title = ({ children }: PropsWithChildren) => (
  <Typography id={htmlId('toast-title')} variant='heading' size='sm' color='inverse'>
    {children}
  </Typography>
);

const Info = ({ children }: PropsWithChildren) => (
  <Typography id={htmlId('toast-info')} size='sm' color='inverse'>
    {children}
  </Typography>
);

const Text = {
  Container: TextContainer,
  Title,
  Info,
};

Toast.Text = Text;

export default Toast;
